import {NgModuleRef} from '@angular/core';

export function hotModuleReplacement(bootloader: () => Promise<NgModuleRef<any>>,
                                     module: any) {
    let MODULE_REF: NgModuleRef<any>;

    if (document.readyState === 'complete') {
        bootloader()
            .then((modRef: NgModuleRef<any>) => MODULE_REF = modRef)
            .then(() => console.timeEnd('bootstrap'));
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            bootloader()
                .then((modRef: NgModuleRef<any>) => MODULE_REF = modRef)
                .then(() => console.timeEnd('bootstrap'));
        });
    }
}



// WEBPACK FOOTER //
// ./src/setup/hot-store.ts